export default "__VITE_ASSET__B1tJH_5s__"